/* Fans Legacy cold-traffic quiz. Content comes from the section's .flq-data JSON; see marketing/quiz/README.md. */
(function () {
  'use strict';

  var wrap = document.querySelector('.flq-wrap');
  if (!wrap) return;
  var root = wrap.querySelector('.flq');
  var data, assets;
  try {
    data = JSON.parse(wrap.querySelector('.flq-data').textContent);
    assets = JSON.parse(wrap.querySelector('.flq-assets').textContent);
  } catch (e) {
    root.innerHTML = '<p class="flq-noscript">The quiz could not load. <a href="/products/lfc-personalised-book">See the book instead</a>.</p>';
    return;
  }

  var screens = data.screens;
  var answers = {};
  var history = [];
  var current = 0;
  var loaderTimer = null;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STORE_KEY = 'flq_' + data.id;
  var pageOverflow = document.documentElement.style.overflow;  // what the theme had, restored after each lock

  /* ---------- the route stamp (reporting/ROUTES.md §3) ----------
     First touch wins for the session: a visitor who arrived on a presell article keeps `presell`.
     Otherwise this session entered by the quiz, and the builder link carries it onward. */
  var ROUTE = '', ROUTE_FROM = '';
  try {
    ROUTE = sessionStorage.getItem('fl_route') || 'quiz';
    ROUTE_FROM = sessionStorage.getItem('fl_from') || data.id;
    sessionStorage.setItem('fl_route', ROUTE);
    sessionStorage.setItem('fl_from', ROUTE_FROM);
  } catch (e) { ROUTE = 'quiz'; ROUTE_FROM = data.id; }
  function stampedBuilderUrl() {
    try {
      var u = new URL(data.builder_url, window.location.origin);
      if (!u.searchParams.get('fl_route')) u.searchParams.set('fl_route', ROUTE);
      if (!u.searchParams.get('fl_from')) u.searchParams.set('fl_from', ROUTE_FROM);
      return u.pathname + u.search + u.hash;
    } catch (e) { return data.builder_url; }
  }

  /* ---------- analytics: Clarity, GA4 and Shopify customer events, each only if present ---------- */
  function track(name, props, done) {
    props = props || {};
    props.quiz = data.id;
    props.fl_route = ROUTE;
    /* `quiz_cta` fires on a link that leaves the page in the same tick; without the beacon the
       browser drops it (2026-10-01 audit: 14 sessions reached the offer, 2 `quiz_cta`). */
    props.transport_type = 'beacon';
    props.send_to = 'G-E8JQ40WZCF';   /* pinned, as in every other fl-*-analytics: the page also configures AW- and GT- tags */
    // Every event carries the flow's labels, so a funnel can be read per club, persona, product and language.
    for (var k in (data.meta || {})) props[k] = data.meta[k];
    try { if (window.clarity) window.clarity('event', 'quiz_' + name); } catch (e) {}
    try {
      /* gtag.js may not have loaded yet on the first screen: queue on its official stub instead of
         dropping the event (2026-10-01 audit: 2 `quiz_start` against 9 sessions on q1). */
      if (typeof window.gtag !== 'function') {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
      }
      var gaProps = {};
      for (var gk in props) gaProps[gk] = props[gk];
      if (done) gaProps.event_callback = done;
      window.gtag('event', 'quiz_' + name, gaProps);
    } catch (e) { if (done) done(); }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('fl_quiz_' + name, props); } catch (e) {}
  }
  function tag(key, value) {
    try { if (window.clarity) window.clarity('set', 'quiz_' + key, String(value)); } catch (e) {}
  }

  /* ---------- content helpers ---------- */
  function lane() {
    var a = answers[data.lane_from];
    return (a && a[0]) || data.default_lane;
  }
  // A text field is a string, or an object of per-lane strings with a "default".
  function pick(v) {
    if (v && typeof v === 'object' && !Array.isArray(v)) return v[lane()] != null ? v[lane()] : v['default'];
    return v;
  }
  function screenById(id) {
    for (var i = 0; i < screens.length; i++) if (screens[i].id === id) return screens[i];
    return null;
  }
  function optionsOf(s) { return pick(s.options) || []; }
  function chosen(qid) {
    var s = screenById(qid), ids = answers[qid] || [];
    if (!s) return [];
    return optionsOf(s).filter(function (o) { return ids.indexOf(o.id) !== -1; });
  }
  function joinList(parts, lastSep) {
    if (parts.length < 2) return parts.join('');
    return parts.slice(0, -1).join(', ') + (lastSep || ' and ') + parts[parts.length - 1];
  }
  function cap(t) { return t ? t.charAt(0).toUpperCase() + t.slice(1) : t; }
  // {q8} -> the answer's "pipe" text, highlighted. {q3.tile} -> its "tile" text, plain.
  function fill(text) {
    var t = pick(text);
    if (!t) return '';
    return t.replace(/\{(\w+)(?:\.(\w+))?\}/g, function (_, qid, field) {
      var opts = chosen(qid);
      if (!opts.length) return '';
      if (field) return cap(opts.map(function (o) { return o[field] || o.label; }).join(', '));
      return '<span class="flq-pipe">' + joinList(opts.map(function (o) { return o.pipe || o.label.toLowerCase(); })) + '</span>';
    });
  }
  // {"q4": ["nothing"]} is true when the q4 answer includes any listed id. Every key must match.
  function matches(cond) {
    for (var qid in cond) {
      var have = qid === 'lane' ? [lane()] : (answers[qid] || []);
      var want = cond[qid];
      var hit = false;
      for (var i = 0; i < want.length; i++) if (have.indexOf(want[i]) !== -1) hit = true;
      if (!hit) return false;
    }
    return true;
  }
  function shown(item) {
    if (item['if'] && !matches(item['if'])) return false;
    if (item.unless && matches(item.unless)) return false;
    return true;
  }
  function skipped(s) { return !!(s.skip && matches(s.skip)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- progress: share of question screens answered so far ---------- */
  // A screen reports the questions already BEHIND it, whatever its type. It used to return 100%
  // for every non-question screen, and the break sits BETWEEN questions: the bar filled on the
  // break, then dropped back to ~78% for the last two - a visitor who thought he was done got
  // asked more. After the last question (loader, result, timeline, offer) this is still 100%.
  function progress() {
    var qs = screens.filter(function (s) { return s.type === 'question' && s.progress !== false && !skipped(s); });
    if (!qs.length) return 1;
    var done = qs.filter(function (q) { return screens.indexOf(q) < current; }).length;
    if (screens[current].type !== 'question') return done / qs.length;
    return Math.max(0.04, done / qs.length);
  }

  /* ---------- drawing ---------- */
  function header(s) {
    var red = s.tone === 'red';
    var back = history.length
      ? '<button type="button" class="flq-back" aria-label="Back"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      : '<span class="flq-back flq-back--empty"></span>';
    var bar = s.progress === false ? '' :
      '<div class="flq-prog" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(progress() * 100) + '"><span style="width:' + Math.round(progress() * 100) + '%"></span></div>';
    // The club mark is optional and its aspect varies by club (LFC's bird is portrait, FCB's
    // licence roundel is square), so it is sized by height in CSS, never by fixed attributes.
    var mark = red ? assets.markOnDark : assets.markOnLight;
    var markImg = mark ? '<span class="flq-rule"></span><img class="flq-mark" src="' + mark +
      '" alt="' + esc((data.meta && data.meta.full_name) || '') + '">' : '';
    return '<div class="flq-top">' + back +
      '<span class="flq-lockup"><span class="flq-wm">FANS LEGACY</span>' + markImg + '</span>' +
      '<span class="flq-back flq-back--empty"></span></div>' + bar;
  }

  // A real, named customer review. Page 1 and the loader both use it. Whoever supplies one must
  // pass the house quoting rule: customer photo or video, and no cross-club twin (presell RECIPE §3).
  function reviewHtml(r) {
    return '<figure class="flq-review"><span class="flq-stars" aria-label="5 stars">★★★★★</span><blockquote>“' +
      esc(r.text) + '”</blockquote><figcaption>' + esc(r.by) + '</figcaption></figure>';
  }

  function drawQuestion(s) {
    var h = '';
    if (s.headline) h += '<h1 class="flq-q flq-q--big">' + pick(s.headline) + '</h1>';
    if (s.sub) h += '<p class="flq-sub">' + pick(s.sub) + '</p>';
    var qTag = s.headline ? 'h2' : 'h1';
    h += '<' + qTag + ' class="flq-q' + (s.headline ? ' flq-q--sub' : '') + '" tabindex="-1">' + fill(s.q) + '</' + qTag + '>';
    var sel = answers[s.id] || [];
    h += '<div class="flq-opts' + (s.multi ? ' flq-opts--multi' : '') + '" role="group">';
    optionsOf(s).forEach(function (o) {
      var on = sel.indexOf(o.id) !== -1;
      h += '<button type="button" class="flq-opt' + (s.big ? ' flq-opt--big' : '') + (on ? ' is-on' : '') + '" data-opt="' + esc(o.id) + '" aria-pressed="' + on + '">' +
        (s.multi ? '<i class="flq-ck" aria-hidden="true"></i>' : '') + '<span>' + esc(o.label) + '</span></button>';
    });
    h += '</div>';
    if (s.multi) h += '<p class="flq-hint">Choose all that apply.</p>';
    // The trust line sits right under the answers: cold traffic assumes a quiz is an email trap,
    // and that assumption costs the first tap before anyone reads the question.
    if (s.foot) h += '<p class="flq-foot">' + fill(s.foot) + '</p>';
    // The review comes AFTER the answers, so the question sits as high as possible on a phone.
    if (s.review) h += reviewHtml(s.review);
    if (s.why) h += '<aside class="flq-why"><b>Why we ask</b>' + fill(s.why) + '</aside>';
    if (s.multi) h += '<button type="button" class="flq-btn flq-next"' + (sel.length ? '' : ' disabled') + '>Next</button>';
    return h;
  }

  function drawBreak(s) {
    var h = '<h1 class="flq-q flq-q--break" tabindex="-1">' + fill(s.title) + '</h1>';
    (s.lines || []).filter(shown).forEach(function (l, i) {
      h += '<p class="flq-line' + (l.punch ? ' flq-punch' : '') + '" style="--i:' + i + '">' + fill(l.text) + '</p>';
    });
    var img = pick(s.image);
    if (img && assets[img]) h += '<div class="flq-photo"><img src="' + assets[img] + '" alt="' + esc(pick(s.image_alt) || '') + '" loading="eager"></div>';
    h += '<button type="button" class="flq-btn flq-go">' + esc(s.button || 'Continue') + '</button>';
    return h;
  }

  function drawLoader(s) {
    var h = '<h1 class="flq-q flq-q--break" tabindex="-1">' + esc(s.title) + '</h1><div class="flq-ring" aria-hidden="true"><span>0%</span></div><div class="flq-checks">';
    s.checks.forEach(function (c) { h += '<div class="flq-check">' + esc(c) + '<span aria-hidden="true">…</span></div>'; });
    h += '</div>';
    // The wait is the one moment he is guaranteed to look at the screen and do nothing - so it
    // carries proof (the TestLibrary funnel runs rotating reviews here). One real review.
    if (s.review) h += '<div class="flq-loader-review">' + reviewHtml(s.review) + '</div>';
    return h;
  }

  function drawResult(s) {
    var h = '<p class="flq-label">' + fill(s.label) + '</p>';
    // A NAMED profile, not just a state: both reference funnels hand back a name ("Inattentive",
    // "Stalled Metabolism"), and a name is what gets remembered and screenshotted. The status line
    // becomes the explanation under it. Scripts without a profile render exactly as before.
    var prof = pick(s.profile);
    h += '<div class="flq-status">';
    if (prof) {
      h += '<p class="flq-kicker">' + fill(s.profile_kicker || '') + '</p>' +
        '<h1 class="flq-profile" tabindex="-1">' + fill(prof) + '</h1>' +
        '<p class="flq-pill">' + fill(s.status) + '</p>';
    } else {
      h += '<h1 class="flq-pill" tabindex="-1">' + fill(s.status) + '</h1>';
    }
    h += '<div class="flq-meter" aria-hidden="true"><i style="left:' + (pick(s.meter) || 30) + '%"></i></div>' +
      '<div class="flq-ml" aria-hidden="true"><span>' + esc(s.meter_low) + '</span><span>' + esc(s.meter_high) + '</span></div></div>';
    h += '<div class="flq-tiles">';
    s.tiles.forEach(function (t) { h += '<div class="flq-tile"><small>' + esc(pick(t.label)) + '</small><span>' + fill(t.text) + '</span></div>'; });
    h += '</div><button type="button" class="flq-btn flq-go">' + esc(pick(s.button)) + '</button>';
    return h;
  }

  function drawTimeline(s) {
    var h = '<h1 class="flq-q" tabindex="-1">' + fill(s.title) + '</h1><ol class="flq-track">';
    s.stops.forEach(function (st) {
      h += '<li class="flq-stop' + (st.now ? ' is-now' : '') + '"><i aria-hidden="true"></i><div><b>' + fill(st.title) + '</b><span>' + fill(st.text) + '</span></div></li>';
    });
    return h + '</ol><button type="button" class="flq-btn flq-go">' + esc(s.button) + '</button>';
  }

  function drawOffer(s) {
    var h = '<h1 class="flq-q" tabindex="-1">' + fill(s.title) + '</h1>';
    var gal = s.gallery && assets.gallery && assets.gallery.length ? assets.gallery : null;
    if (gal) {
      // The product page's own gallery: one image at a time, arrows, dots, swipe.
      h += '<div class="flq-gal" role="region" aria-roledescription="carousel" aria-label="The book, from the product page"><div class="flq-gal-track">';
      gal.forEach(function (im, i) {
        h += '<div class="flq-gal-slide" role="group" aria-roledescription="slide" aria-label="' + (i + 1) + ' of ' + gal.length + '">' +
          '<img src="' + esc(im.src) + '" alt="' + esc(im.alt || '') + '"' + (i ? ' loading="lazy"' : '') + ' width="900" height="900"></div>';
      });
      h += '</div><button type="button" class="flq-gal-arrow flq-gal-prev" aria-label="Previous image"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<button type="button" class="flq-gal-arrow flq-gal-next" aria-label="Next image"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<div class="flq-gal-dots" aria-hidden="true">';
      gal.forEach(function (_, i) { h += '<i' + (i ? '' : ' class="is-on"') + '></i>'; });
      h += '</div></div>';
      // The product's own name, read live from the PDP (like the gallery), so the offer says
      // what it is. Omitted if the section could not resolve the product.
      if (assets.productTitle) h += '<p class="flq-prod">' + esc(assets.productTitle) + '</p>';
    } else {
      h += '<div class="flq-two">';
      s.images.forEach(function (im) { if (assets[im.key]) h += '<img src="' + assets[im.key] + '" alt="' + esc(im.alt) + '" loading="lazy">'; });
      h += '</div>';
    }
    if (s.note) h += '<p class="flq-note">' + esc(s.note) + '</p>';
    s.paras.filter(shown).forEach(function (p) { h += '<p class="flq-para">' + fill(p.text) + '</p>'; });
    h += '<ul class="flq-ticks">';
    s.ticks.forEach(function (t) { h += '<li>' + esc(t) + '</li>'; });
    h += '</ul><a class="flq-btn flq-cta" href="' + esc(stampedBuilderUrl()) + '">' + esc(s.button) + '</a>';
    return h;
  }

  var DRAW = { question: drawQuestion, 'break': drawBreak, loader: drawLoader, result: drawResult, timeline: drawTimeline, offer: drawOffer };

  // Every screen starts at the top, and it has to survive a phone.
  // Three things fight us: the theme sets `scroll-behavior: smooth` on <html> (so scrollTo
  // becomes a glide a phone can cut short), momentum scrolling keeps moving AFTER the tap that
  // changed the screen, and scroll anchoring tries to hold the old position. So: kill the
  // momentum by clamping overflow for one frame, jump instantly, and re-assert it a few times
  // over the next quarter second - by then the flick is spent.
  function jumpTop() {
    var de = document.documentElement, prev = de.style.scrollBehavior;
    de.style.scrollBehavior = 'auto';
    try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, 0); }
    de.scrollTop = 0;
    document.body.scrollTop = 0;
    de.style.scrollBehavior = prev;
  }

  // One lock at a time: two overlapping calls used to restore "hidden" as the previous value and
  // leave the page unscrollable. And the release never rides on requestAnimationFrame alone - a
  // backgrounded tab doesn't run frames, which would leave the page frozen until it came back.
  var scrollLocked = false;
  function releaseScroll() {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.documentElement.style.overflow = pageOverflow;
    jumpTop();
  }
  function toTop() {
    jumpTop();
    if (!scrollLocked) {
      scrollLocked = true;
      document.documentElement.style.overflow = 'hidden';  // stops a running flick dead
      requestAnimationFrame(releaseScroll);
      setTimeout(releaseScroll, 120);
    }
    setTimeout(jumpTop, 200);
  }

  function render(dir) {
    var s = screens[current];
    clearTimeout(loaderTimer);
    toTop();
    root.className = 'flq flq--' + (s.tone === 'red' ? 'red' : 'light') + ' flq--' + s.type + (reduced ? '' : ' flq-in' + (dir === 'back' ? ' flq-in--back' : ''));
    root.innerHTML = header(s) + '<div class="flq-body">' + DRAW[s.type](s) + '</div>';
    document.documentElement.classList.toggle('flq-page-red', s.tone === 'red');
    var focus = root.querySelector('[tabindex="-1"]');
    if (focus) try { focus.focus({ preventScroll: true }); } catch (e) {}
    toTop();
    requestAnimationFrame(toTop);
    track('step_' + s.id, { step: s.id, lane: lane() });
    if (s.type === 'loader') runLoader(s);
    if (s.type === 'offer') initGallery();
  }

  function initGallery() {
    var gal = root.querySelector('.flq-gal');
    if (!gal) return;
    var rail = gal.querySelector('.flq-gal-track'), dots = gal.querySelectorAll('.flq-gal-dots i');
    var n = rail.children.length, idx = 0, seen = { 0: 1 }, x0 = null, y0 = null, dx = 0, horizontal = null;
    function show(i) {
      idx = (i + n) % n;
      rail.style.transition = '';
      rail.style.transform = 'translateX(' + (-idx * 100) + '%)';
      for (var k = 0; k < dots.length; k++) dots[k].className = k === idx ? 'is-on' : '';
      if (!seen[idx]) { seen[idx] = 1; track('gallery_' + (idx + 1), {}); }
    }
    gal.querySelector('.flq-gal-prev').addEventListener('click', function () { show(idx - 1); });
    gal.querySelector('.flq-gal-next').addEventListener('click', function () { show(idx + 1); });
    // Swipe: follow the finger sideways, let vertical drags scroll the page.
    rail.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; horizontal = null;
    }, { passive: true });
    rail.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;
      if (horizontal === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) horizontal = Math.abs(dx) > Math.abs(dy);
      if (!horizontal) return;
      rail.style.transition = 'none';
      rail.style.transform = 'translateX(calc(' + (-idx * 100) + '% + ' + dx + 'px))';
    }, { passive: true });
    rail.addEventListener('touchend', function () {
      if (x0 === null) return;
      if (horizontal && Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); else show(idx);
      x0 = null;
    });
  }

  function runLoader(s) {
    var checks = root.querySelectorAll('.flq-check');
    var ring = root.querySelector('.flq-ring span');
    var step = reduced ? 300 : 1200, i = 0;
    function tick() {
      if (i < checks.length) {
        checks[i].classList.add('is-done');
        checks[i].querySelector('span').textContent = '✓';
        i++;
        ring.textContent = Math.round((i / checks.length) * 100) + '%';
        root.querySelector('.flq-ring').style.setProperty('--p', i / checks.length);
        loaderTimer = setTimeout(tick, step);
      } else {
        loaderTimer = setTimeout(function () { go(1); }, reduced ? 200 : 500);
      }
    }
    loaderTimer = setTimeout(tick, reduced ? 100 : 400);
  }

  function nextIndex(from) {
    var i = from + 1;
    while (i < screens.length && skipped(screens[i])) i++;
    return i;
  }

  function go() {
    var n = nextIndex(current);
    if (n >= screens.length) return;
    if (screens[current].type !== 'loader') history.push(current);
    current = n;
    if (screens[current].type === 'result') { track('complete', answerProps()); tag('lane', lane()); }
    save();
    render('fwd');
  }

  function back() {
    if (!history.length) return;
    current = history.pop();
    render('back');
  }

  // The finish event carries every answer (ids only, nothing personal), so we can see which pains people pick.
  function answerProps() {
    var p = { lane: lane() };
    for (var qid in answers) p[qid] = answers[qid].join('|');
    return p;
  }

  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ answers: answers, lane: lane(), at: Date.now() })); } catch (e) {}
  }

  /* ---------- input ---------- */
  // A break screen advances on a tap ANYWHERE, not only on the button (Tomer, 2026-09-21).
  // ANYWHERE means the whole page, not just the quiz column (Tomer, 2026-09-29): on a wide
  // screen the column is under half the window, and a click on the coloured sides did nothing.
  // Guarded only against a drag and a text selection. The old "page scrolled more than 4px
  // during the tap" guard is gone: it swallowed real taps on phones, and a browser does not
  // fire a click after a scroll gesture anyway.
  var tapY = null, tapMoved = false;
  document.addEventListener('pointerdown', function (e) {
    tapY = e.clientY; tapMoved = false;
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (tapY !== null && Math.abs(e.clientY - tapY) > 10) tapMoved = true;
  }, { passive: true });
  function tappedCleanly() {
    if (tapMoved) return false;
    var sel = window.getSelection && window.getSelection();
    return !(sel && String(sel).length > 1);
  }
  // Clicks outside the quiz column (the page around it) - the column's own clicks are handled below.
  document.addEventListener('click', function (e) {
    // e.flqSeen: the column's handler already ran. Needed because that handler re-renders, which
    // detaches the target - so Back from the next screen would land on the break and bounce forward.
    if (e.flqSeen || root.contains(e.target) || root.classList.contains('is-locked')) return;
    if (screens[current].type === 'break' && tappedCleanly()) go();
  });

  root.addEventListener('click', function (e) {
    e.flqSeen = true;
    var s = screens[current];
    if (root.classList.contains('is-locked')) return;
    if (e.target.closest('.flq-back:not(.flq-back--empty)')) { back(); return; }
    if (e.target.closest('.flq-go')) { go(); return; }
    var cta = e.target.closest('.flq-cta');
    if (cta) {
      /* MEASURED 2026-10-01: gtag holds the result/offer screens in its batch until the tap, and the
         tap itself was never sent — the page left first. So hold the navigation until GA4 confirms
         the send, never longer than 800 ms. A modified click (new tab) is left alone. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) { track('cta', { lane: lane() }); save(); return; }
      e.preventDefault();
      var href = cta.getAttribute('href'), left = false;
      var leave = function () { if (left) return; left = true; window.location.href = href; };
      save();
      track('cta', { lane: lane() }, leave);
      setTimeout(leave, 800);
      return;
    }
    if (s.type === 'break' && tappedCleanly()) { go(); return; }
    var nextBtn = e.target.closest('.flq-next');
    if (nextBtn) { if ((answers[s.id] || []).length) go(); return; }

    var btn = e.target.closest('.flq-opt');
    if (!btn || s.type !== 'question') return;
    var id = btn.getAttribute('data-opt');
    if (s.multi) {
      var opt = optionsOf(s).filter(function (o) { return o.id === id; })[0];
      var cur = (answers[s.id] || []).slice();
      if (cur.indexOf(id) !== -1) cur.splice(cur.indexOf(id), 1);
      else if (opt && opt.exclusive) cur = [id];
      else cur = cur.filter(function (x) {
        var o = optionsOf(s).filter(function (p) { return p.id === x; })[0];
        return !(o && o.exclusive);
      }).concat(id);
      answers[s.id] = cur;
      root.querySelectorAll('.flq-opt').forEach(function (b) {
        var on = cur.indexOf(b.getAttribute('data-opt')) !== -1;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on);
      });
      root.querySelector('.flq-next').disabled = !cur.length;
      return;
    }
    answers[s.id] = [id];
    if (s.id === data.lane_from) tag('lane', id);
    root.querySelectorAll('.flq-opt').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
    root.classList.add('is-locked');
    setTimeout(function () { root.classList.remove('is-locked'); go(); }, reduced ? 60 : 280);
  });

  // An ad can ask the first question itself and send the answer in the link
  // (…/quiz-lfc-superfan-prs?q1=life&q2=24). Those screens are treated as already answered and
  // never shown, so the visitor lands on the first thing they haven't answered - the commitment
  // is made in the ad, not on the page. Unknown ids are ignored, so a stale link still works.
  function prefill() {
    var params, used = [];
    try { params = new URLSearchParams(location.search); } catch (e) { return used; }
    screens.forEach(function (s) {
      if (s.type !== 'question') return;
      var raw = params.get(s.id);
      if (!raw) return;
      var ids = raw.split(',').filter(function (id) {
        return optionsOf(s).some(function (o) { return o.id === id; });
      });
      if (!ids.length) return;
      answers[s.id] = s.multi ? ids : [ids[0]];
      used.push(s.id);
    });
    // Start on the first screen that isn't answered or skipped. No history: they never saw these.
    while (current < screens.length &&
           ((screens[current].type === 'question' && answers[screens[current].id]) || skipped(screens[current]))) {
      current++;
    }
    return used;
  }

  var prefilled = prefill();
  for (var k in (data.meta || {})) tag(k, data.meta[k]);
  /* Sent 1.5 s after load: fired in the first tick it left before GA4's own page_view and was
     largely not counted (2026-10-01: 2 `quiz_start` against 9 sessions on q1). */
  var startProps = prefilled.length ? { prefilled: prefilled.join('|') } : {};
  setTimeout(function () { track('start', startProps); }, 1500);
  render('fwd');
})();
